import type { ChangeEvent } from 'react'

import { Tooltip as ReactTooltip } from 'react-tooltip'

import { Box } from 'app/components/design-system-components'
import { CheckBoxGeneral } from 'app/components/forms/forms'
import {
  PREMIER_UPGRADE_TOOLTIP_SUFFIX,
  TEAM_ADMIN_UPDATE_TOOLTIP_SUFFIX,
} from 'app/sm/team_viewing_preference/applications/premier-plan-setting.constants'
import { applicationsAttributesIDs } from 'app/sm/team_viewing_preference/applications-attributes.constants'

const TOOLTIP_ID = 'ownerDecisionNotifyTeamInfo'

export const OWNER_DECISION_NOTIFY_TEAM_LABEL =
  'Notify team when owner approves or declines shared application'

export const OWNER_DECISION_NOTIFY_TEAM_TOOLTIP =
  'When enabled, BDMs and the leasing operations email are notified when an owner approves or declines a shared application, in addition to the property-assigned team members.'

export const getOwnerDecisionNotifyTeamTooltipText = ({
  isAccountPremier,
  isUserAdmin,
}: Pick<
  OwnerDecisionNotifyTeamSettingProps,
  'isAccountPremier' | 'isUserAdmin'
>) =>
  `${OWNER_DECISION_NOTIFY_TEAM_TOOLTIP} ${
    !isAccountPremier
      ? PREMIER_UPGRADE_TOOLTIP_SUFFIX
      : !isUserAdmin
      ? TEAM_ADMIN_UPDATE_TOOLTIP_SUFFIX
      : ''
  }`.trim()

export interface OwnerDecisionNotifyTeamSettingProps {
  isVisible: boolean
  isChecked: boolean
  isUserAdmin: boolean
  isAccountPremier: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export const OwnerDecisionNotifyTeamSetting = ({
  isVisible,
  isChecked,
  isUserAdmin,
  isAccountPremier,
  onChange,
}: OwnerDecisionNotifyTeamSettingProps): JSX.Element | null => {
  if (!isVisible) {
    return null
  }

  const isDisabled = !isUserAdmin || !isAccountPremier
  const tooltipText = getOwnerDecisionNotifyTeamTooltipText({
    isAccountPremier,
    isUserAdmin,
  })

  return (
    <>
      <div className="mb15">
        <CheckBoxGeneral
          id={applicationsAttributesIDs.shareApplicationOwnerDecisionNotifyTeam}
          label={OWNER_DECISION_NOTIFY_TEAM_LABEL}
          onChange={onChange}
          checked={isChecked}
          eventProcessedByComponent
          disabled={isDisabled}
          showDisabledGrey={isDisabled}
          toolTip={
            (
              <div>
                <i
                  className="icon-help-outline fs16 gray-light-color ibm"
                  data-tooltip-content=""
                  data-tooltip-id={TOOLTIP_ID}
                />
              </div>
            ) as unknown as string // CheckBoxGeneral is a JS base component; proper toolTip typing needs changes there first.
          }
        />
      </div>

      <div>
        <ReactTooltip id={TOOLTIP_ID} className="tool-tip-style">
          <Box maxWidth="260px">{tooltipText}</Box>
        </ReactTooltip>
      </div>
    </>
  )
}

export default OwnerDecisionNotifyTeamSetting
